import React from "react";
import { Modal } from "antd";
import "./DeleteSurveyPopup.scss";

const DeleteSurveyPopup = ({
  isVisible,
  handleCancel,
  title,
  children,
  className,
}) => {
  return (
    <Modal
      visible={isVisible}
      onCancel={handleCancel}
      title={title}
      footer={null}
      className={`${className} survey-modal`}
      centered
    >
      {children}
    </Modal>
  );
};

export default DeleteSurveyPopup;
